// src/components/common/tooltip.tsx
'use client';

import { TooltipContent, Tooltip as TooltipRoot, TooltipTrigger } from '@/components/ui/tooltip';
import * as React from 'react';

interface SimpleTooltipProps {
  /** The content to display in the tooltip */
  content: React.ReactNode;
  /** The element that triggers the tooltip */
  children: React.ReactNode;
  /** Which side the tooltip should appear */
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** Alignment of the tooltip */
  align?: 'start' | 'center' | 'end';
  /** Offset from the trigger element */
  sideOffset?: number;
  /** Additional class for tooltip content */
  className?: string;
  /** Disable the tooltip */
  disabled?: boolean;
}

export function SimpleTooltip({
  content,
  children,
  side = 'top',
  align = 'center',
  sideOffset = 6,
  className,
  disabled = false,
}: SimpleTooltipProps) {
  if (disabled || !content) {
    return <>{children}</>;
  }

  return (
    <TooltipRoot>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} align={align} sideOffset={sideOffset} className={className}>
        {content}
      </TooltipContent>
    </TooltipRoot>
  );
}
